<template>

	<div class="card">
		<!-- Services header with edit lock/unlock -->
		<div class="grid">
			<!-- Title -->
			<div class="col">
				<h4>Users</h4>
			</div>
		</div>

		<div style="margin-bottom:10px;" class="grid ml-0 mr-1">
			<!-- Filter text box -->
			<div class="flex flex-auto p-input-icon-left p-input-icon-right mt-1">
				<i class="pi pi-home" />
				<InputText v-model="userSearchFilter" placeholder="Service keyword filter.." />
				<i class="pi pi-search" />
			</div>
			<Button icon="pi pi-plus" label="New" @click="newUser" class="p-button-rounded ml-1 md:ml-2 mt-1" />
		</div>

			<!--Pricing Summary table-->
			<DataView :value="filteredUsers"
					  datakey="loginId"
					  :paginator="true"
					  :rows="100"
					  :scrollable="true"
					  stripedRows
					  class="p-datatable-sm"
					  :paginatorTemplate="paginatorTemplate"
					  :rowsPerPageOptions="[10,20,50,100,200]"
					  responsiveLayout="scroll"
					  :alwaysShowPaginator="false"
					  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">

				<template #header>
					<div class="col-12">
						<div class="grid flex-nowrap">
							<div class="col-3">ID</div>
							<div class="col-3">Email</div>
							<div class="col-3">Access roles</div>
							<div class="col-3">Last Login</div>
						</div>
					</div>
				</template>

				<template #list="{data}">
					<div class="col-12 property-service-item hover-row">

						<!-- User details  -->
						<div class="grid flex-nowrap">
							<div class="col-3 ml-4 compass-red">
								<router-link :to="{ name: 'UserDetails', params: { loginId: data.loginId }}">{{data.loginId}}</router-link>
							</div>
							<div class="col-3 compass-red">
								<router-link :to="{ name: 'UserDetails', params: { loginId: data.loginId }}">{{data.loginEmail}}</router-link>
							</div>
							<div class="col-3">
								{{formattedRoles(data.accessRoles)}}
							</div>
							<div class="col-3">
								{{formattedDate(data.whenLastLogin)}}
							</div>
						</div>
					</div>
				</template>

				<template #empty>
					<div class="text-center pt-2 pb-2">
						No records found.
					</div>
				</template>
			</DataView>
		</div>

</template>

<script lang="ts">
	import { Vue } from 'vue-class-component';
	import { CompassApi } from '@/api-client/CompassApiProxy';
	import { UserData } from '../api-client/api-client';
	import filterListBySearchString from '@/utils/StringSearch';
	import { format, isValid } from 'date-fns';
	import Toast from '@/utils/Toast';
	import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';

	Vue.registerHooks([
		'beforeRouteEnter',
		'beforeRouteLeave',
	]);

	export default class UserList extends Vue {

		userSearchFilter = "";

		loading = true;

		editMode = false;

		users: UserData[] = [];

		  beforeRouteEnter(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
			next((vm: Vue) => {
				(vm as UserList).getUserList();
			});
		}

		getUserList() {
			const apiClient = CompassApi.userApi(this.$store);
			apiClient.getUserList()
				.then(result => {
					if (result != null) {
						this.users = result;
					}
					this.loading = false;
				})
				.catch(error => {
					this.loading = false;
					Toast.ApiError('Error retrieving users ', error);
				});
		}

		newUser() {
			this.$router.push({
				name: 'NewUser'
			});
		}

		// helpers
		formattedDate(date: Date) {
			if (!isValid(date)) return;

			return format(date, 'd MMM yyyy');
		}

		formattedRoles(roles: string) {
			if (roles == null)
				return "";
			roles = roles.trim();
			roles = roles.replace("Compass", "Compass ");
			roles = roles.replace("External", "External ");
			roles = roles.replace(/;$/, ""); // Removing trailing semi-colon
			return roles;
		}

		// Computed
		get filteredUsers() {
			let list = this.users as UserData[];

			list = filterListBySearchString(list, this.userSearchFilter,
				(el) => el.loginId
					+ ' ' + el.loginEmail
					+ ' ' + el.accessRoles);

			return list;
		}

		// Computed isDesktop
		get isDesktop() {
			return window.innerWidth >= 992;
		}

		// Computed to simplify paginator on mobile
		get paginatorTemplate() {
			return this.isDesktop ?
				"CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
				: "PrevPageLink NextPageLink"
		}
	}
</script>

<style scoped lang="scss">
</style>